clientDefaultOptions